import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import makeStyles from '@material-ui/core/styles/makeStyles';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import React from 'react';
import {BookmarkLinkGroupWithId} from './Home';

const useStyles = makeStyles(theme => ({
    link: {
        color: theme.palette.primary[theme.palette.type === 'light' ? 'main' : 'light'],
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    icon: {
        marginLeft: theme.spacing(1),
        fontSize: 16,
    },
}));

type Props = {
    linkGroups : BookmarkLinkGroupWithId[];
};

const DefaultView : React.FC<Props> = ({linkGroups} : Props) => {
    const classes = useStyles();

    return (
        <Grid container spacing={2}>
            {linkGroups.map(linkGroup => (
                <Grid item xs={12} sm={6} md={4} key={linkGroup.id}>
                    <Card>
                        <CardHeader title={linkGroup.name}/>
                        <List dense component="div">
                            {linkGroup.links.map(link => (
                                <ListItem
                                    key={link.id}
                                    component="a"
                                    href={link.url}
                                    target={link.openInNew ? '_blank' : '_self'}
                                    rel="noopener"
                                    className={classes.link}
                                >
                                    <ListItemText>
                                        {link.title}
                                        {link.openInNew && <OpenInNewIcon className={classes.icon}/>}
                                    </ListItemText>
                                </ListItem>
                            ))}
                        </List>
                    </Card>
                </Grid>
            ))}
        </Grid>
    );
};

export default DefaultView;
